
import Selector from "./Selector"
import { useEffect, useState } from "react";



function FetchYearDropdown({passData, resetDemographicsDropdown, resetMovementDropdown, resetDropdownValue}) {

    const [Data, setData] = useState([])
    

    useEffect(() => {
        var url = '/api/years';
        fetch(url).then((res) =>
            res.json().then((res) => {
                setData(res.data.Years)

          })
        )
        .catch((error) => {
          console.log("Refetching data!")
        });
      }, []);
    
      let SelectorData =  Data.map(x => ({value: x, label: x}));


      
      const yearSelector1Options = {
        title: "",
        defaultText: "Έτος",
        options: SelectorData
    }

    
    
    return (
        <Selector props = {yearSelector1Options} onSelect = {passData} resetDropdown1 = {resetDemographicsDropdown} resetDropdown2 = {resetMovementDropdown} resetDropdownValue = {resetDropdownValue}></Selector>
      );

    };

export default FetchYearDropdown;

